import { RouterProvider } from "react-router-dom";
import mainRouter from "routes";
import GlobalStyle from "style/global.style";
import { Provider } from 'react-redux';
import store from 'store';
import AudioPlayer from "components/custom/audio";
import I18nButton from "components/custom/i18n-button";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Text,
  HStack,
} from '@chakra-ui/react'
import { useEffect, useState } from "react";
import { Button } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next';

function App() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isEnableSong, setIsEnableSong] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setTimeout(() => {
      onOpen();
    }, 800); // Chama onOpen após 1 segundo (1000 milissegundos)
  }, [onOpen])

  const enableSong = () => {
    setIsEnableSong(true);
    onClose();
  }

  return (
    <div className="App">
      <GlobalStyle />
      <Provider store={store}>
        <I18nButton />
        <RouterProvider router={mainRouter} />
      </Provider>
      <AudioPlayer isEnableSong={isEnableSong} />
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Text style={{
              fontFamily: "var(--body-font)"
            }}>
              {t('common.notification')}
            </Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text style={{
              fontFamily: "var(--body-font)"
            }}>
              {t('home.musicQuestion')}
            </Text>
          </ModalBody>

          <ModalFooter>
            <HStack spacing={2}>
              <Button colorScheme="blue" onClick={() => enableSong()}>
                <Text style={{
                  fontFamily: "var(--body-font)"
                }}>
                  {t('common.yes')}
                </Text>
              </Button>
              <Button onClick={onClose}>
                <Text style={{
                  fontFamily: "var(--body-font)"
                }}>
                  {t('common.close')}
                </Text>
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
}

export default App;
